import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import { connect } from "react-redux";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';


class NewUser extends Component {

    constructor(props) {
        super(props);

        this.state = {
            setrole: "",
            settendant: "",
            roleerror: false
          }
    
    }
         
     handleChangeRole = (event) =>{   
        this.setState ({
            setrole: event.target.value    
        })
      }

      handleChangeTendant = (event) =>{   
        this.setState ({
            settendant: event.target.value    
        })
      }



    submitnewuser = (event) =>{  
        event.preventDefault()
       

        let jsonfields= "";
        jsonfields += '"accountId": "' + this.state.settendant + '",';
        jsonfields += '"firstName": "' + event.currentTarget.firstName.value + '",';
        jsonfields += '"lastName": "' + event.currentTarget.lastName.value + '",';
        jsonfields += '"email": "' + event.currentTarget.email.value + '",';
        jsonfields += '"userName": "' + event.currentTarget.email.value + '",';
        jsonfields += '"password": "' + event.currentTarget.password.value + '",';
        jsonfields += '"description": "' + event.currentTarget.description.value + '",';
        jsonfields += '"isAdminRole": "false",';
        jsonfields += '"isActive": "true",';
        
        let jsonafields="";
        jsonafields += '"roleId": "' + this.state.setrole + '",';
        jsonafields += '"accountId": "' + this.state.settendant + '"';

        let json = "";
        json = '{';
        json += jsonfields;
        //json += '"authorizations": [{';
        //json += jsonafields;
        //json += '}]';
        json += '}';

        if (this.state.settendant !== "" ){
            this.setState ({
                roleerror: false    
            })
         this.postnewuser(this.props.apitoken, json)   
        } else {
            console.log (this.state)
            this.setState ({
                roleerror: true    
            })
        }
    }


    postnewuser (token,json)  {
        let apiurl = window.apiurl
        fetch("https://"+apiurl+"/api/User", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token,
            },
            body: json
          })
            .then(res => res.json())
            .then(json => {
              console.log("---------------")
              console.log(json)
              console.log("---------------")
              this.props.closedit()  
              
            })
            .catch(function(error) {
                console.log(error.status);
              });         
          }


    render () {  

        const roles = this.props.roles
        const admintenants = this.props.admintenants

        return (
           <Fragment>
               <Container maxWidth="sm">
               <CloseIcon onClick={()=>this.props.closedit()} />

               <Typography variant="h6" gutterBottom>
               {intl.get('ADMIN_NEWUSER_FORM')} :
      </Typography>

        

      <Box component="form" onSubmit={this.submitnewuser}  Validate >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            required
            id="firstName"
            name="firstName"
            label={intl.get('ACCOUNT_EDIT_FORM_VORNAME')}
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="lastName"
            name="lastName"
            label={intl.get('ACCOUNT_EDIT_FORM_NACHNAME')}
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="email"
            name="email"
            label={intl.get('ADMIN_NEWUSER_FORM_EMAIL')}
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="password"
            name="password"
            label={intl.get('ADMIN_NEWUSER_FORM_PW')}
            fullWidth
            type="password"
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            name="description"
            label={intl.get('ADMIN_NEWUSER_FORM_DESC')}
            multiline
            rows={4}
            fullWidth
            variant="standard"
          />
        </Grid>

        
        <Grid item xs={12}>
          <select className="userselect" onChange={this.handleChangeTendant}>
                                <option key="0" value="">{intl.get('ADMIN_LISTSELECT_TENANT')}</option>
                                {admintenants.map(tenant => {
                                  return (<option key={tenant.id} value={tenant.id}>{tenant.name}</option>);
                                })
                              }           
          </select>
            </Grid>
            <Grid item xs={12}>
            <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {intl.get('ADMIN_NEWUSER_FORM_SUBMIT')}
          </Button>
          </Grid>

      </Grid>
      </Box>
      </Container>
      </Fragment> 
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken,
    roles: state.getroles.roles,
    tendants: state.getroles.accounts,
    admintenants: state.getuserdata.admintenants
  });
  
  export default connect(mapStateToProps)(NewUser);

  /* 
  <Grid item xs={12}>
        {this.state.roleerror &&
        <Fragment>
           <Alert severity="error">{intl.get('ADMIN_NEWUSER_FORM_ALERT')}</Alert>
           <hr />
        </Fragment>
        }

                <select className="userselect" onChange={this.handleChangeRole}>
                                <option key="0" value="">{intl.get('ADMIN_LISTSELECT_ROLLE')}</option>
                              {roles.map(item => {
                                  return (<option key={item.id} value={item.id}>{item.name}</option>);
                                })
                              }
                </select>
        </Grid>
*/

